
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 253"}},[_c('g',{attrs:{"data-name":"Group 252"}},[_c('path',{attrs:{"data-name":"Path 105","d":"M633.12 201.64L372.27.21 55.67 206.36v794.34l311.21-202.61 260.85 201.43 316.6-205.88V-.7zM838.17 736L683.51 836.51V295.43l154.66-100.51zm-676.34 69V263.64l154.66-100.51v541.06zm260.68-98.08V173.36L577.19 293v533.2z","fill":"#0f59ec"}})])])])
          )
        }
      }
    